<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex style="max-width:500px">
        <v-card v-if="statusAccountActivation === 'success'" flat>
          <v-alert type="info" value="1">Email bestätigt</v-alert>
          <v-card-text>Herzlichen Dank für die Registrierung. Sie erhalten ein Email, sobald Ihr Account seitens des Administrators freigeschalten worden ist.</v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>

          </v-card-actions>
        </v-card>
        <v-card v-else-if="statusAccountActivation === 'failure'" flat>
          <v-alert type="error" value="1">Aktivierung fehlgeschlagen.</v-alert>
          <v-card-text>Möglicherweise ist Ihr Account bereits aktiviert. Bitte probieren Sie sich anzumelden.</v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  computed: {
    ...mapState({
      statusAccountActivation: ({ user }) => user.statusAccountActivation,
      statusAuth: ({ auth }) => auth.status,
      loading: function() {
        return this.statusAccountActivation === "fetching";
      }
    })
  },

  mounted() {
    if (this.statusAuth === "success") {
      this.logout();
    } else {
      this.activateAccount({ token: this.$route.params.token });
    }
  },

  watch: {
    statusAccountActivation(val) {
      if (val === "success") {
        // setTimeout(() => {
        //   this.$router.push("/login");
        // }, 3000);
      }
    }
  },

  methods: {
    ...mapActions("user", ["activateAccount"]),
    ...mapActions("auth", ["logout"])
  }
};
</script>
